/*
 * @Author: Narcissus
 * @Date: 2022-12-05 11:08:59
 * @LastEditTime: 2022-12-14 10:05:45
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \analysis_chemical_shift_table\ui\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      // redirect: '/entrance?ticket=ticket_XV56Uy7GByPONtqf143KzfOKQeYM7h1670927699',
      // redirect:'/:ticket',
      name: 'entrance',
      component: () => import('@/views/entrance/index')
    },
    {//ui\src\views\home\index.vue
      path: '/home/:id',
      name: 'home',
      component: () => import('@/views/home/index')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js